var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-badge',{attrs:{"count":_vm.$store.state.num}},[_c('a',{staticClass:"action ant-dropdown-link user-dropdown-menu",on:{"click":_vm.HoldOrder}},[_vm._v(" 挂起订单 ")])]),_c('hold-order-model',{ref:"model"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }